import { createSlice } from "@reduxjs/toolkit";
import { createMachineModel, updateMachineModel, readMachine, getMachinesByModel } from "./actions";

const initialState = {
  loading: false,
  machineModel: [],
  // machineDetailsView: {},
  error: null,
  success: false,
  customerSerialNumberView: []
};

const commonSlice = createSlice({
  name: "machines",
  initialState,
  reducers: {},
  extraReducers: {
    [createMachineModel.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [createMachineModel.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [createMachineModel.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    [updateMachineModel.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [updateMachineModel.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [updateMachineModel.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // [readMachine.pending]: (state) => {
    //   state.isLoading = true;
    //   state.error = null;
    // },
    // [readMachine.fulfilled]: (state, { payload }) => {
    //   state.isLoading = false;
    //   state.machineDetailsView = payload;
    // },
    // [readMachine.rejected]: (state, { payload }) => {
    //   state.isLoading = false;
    //   state.error = payload;
    // },

    [getMachinesByModel.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getMachinesByModel.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.customerSerialNumberView =  payload;
    },
    [getMachinesByModel.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    
  },
});

export default commonSlice.reducer;
